/* src/app/app.component.scss */
:host {
  font-family: var(--font-family);
}
/*# sourceMappingURL=app.component.css.map */
